  <mat-form-field [style]="style" [floatLabel]="floatLabel" [appearance]="appearance? appearance: null" data-cy="tdo-dropdown-form-field">
     <mat-label *ngIf="tdolabel" data-cy="tdo-dropdown-label">{{tdolabel}}</mat-label>
    <mat-select [style]="appearance? null: style" [disabled]="disabled" [style.height.px]="height" [placeholder]="placeholder" [(value)]="value" (selectionChange)="onChange($event)" [attr.data-cy]="cypressControlIdentifier ? cypressControlIdentifier : 'tdo-dropdown-select'">
      <ng-container *ngIf="dataSourceDisplayKey !== undefined && isObjectValue === true">
        <mat-option [disabled]="disabled" *ngFor="let obj of dataSource; let i = index" [value]="obj" [attr.data-cy]="cypressControlIdentifier ? cypressControlIdentifier + '-' + i : 'tdo-dropdown-option-' + i">
          {{obj[dataSourceDisplayKey]}}{{suffix}}
        </mat-option>
      </ng-container>
      <ng-container *ngIf="dataSourceDisplayKey !== undefined && isObjectValue === undefined">
        <mat-option [disabled]="disabled" *ngFor="let obj of dataSource; let i = index" [value]="obj[dataSourceDisplayKey]" [attr.data-cy]="cypressControlIdentifier ? cypressControlIdentifier + '-' + i : 'tdo-dropdown-option-' + i">
          {{obj[dataSourceDisplayKey]}}{{suffix}}
        </mat-option>
      </ng-container>
      <ng-container *ngIf="dataSourceDisplayKey === undefined">
        <mat-option [disabled]="disabled" *ngFor="let obj of dataSource; let i = index" [value]="obj" [attr.data-cy]="cypressControlIdentifier ? cypressControlIdentifier + '-' + i : 'tdo-dropdown-option-' + i">
          {{obj}}{{suffix}}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
 